module.exports = __webpack_public_path__ + "img/jpCustomerService.bdda1af.png";